import type en from '../en/nav'
import type { Translation } from '../types'

/** The menu and the frame around every page */
const nav: Translation<typeof en> = {
  "nav.overview": "Vue d’ensemble",
  "nav.admins": "Administrateurs",
  "nav.models": "Modèles",
  "nav.companies": "Entreprises",
  "nav.settings": "Paramètres",
  "nav.vpn": "VPN",
  "nav.edge": "Proxy de périphérie",
  "nav.licensePlans": "Formules de licence",
  "nav.licenseOverview": "Vue d’ensemble des licences",
  "nav.myProfile": "Mon profil",
  "nav.dashboard": "Tableau de bord",
  "nav.monitoring": "Surveillance",
  "nav.alerts": "Alertes",
  "nav.sites": "Sites",
  "nav.templates": "Modèles",
  "nav.users": "Utilisateurs",
  "nav.roles": "Rôles",
  "nav.branding": "Image de marque",
  "nav.messages": "Messages",
  "nav.apiKeys": "Clés API",
  "nav.webhooks": "Webhooks",
  "nav.notifications": "Notifications",
  "nav.roleGlobalAdmin": "Administrateur global",
  "nav.roleAdmin": "Administrateur",
  "nav.roleUser": "Utilisateur",
  "nav.switchCompany": "Changer d’entreprise",
  "nav.logout": "Se déconnecter",
  "nav.expand": "Déplier",
  "nav.collapse": "Replier",
  "nav.expandMenu": "Déplier le menu",
  "nav.collapseMenu": "Replier le menu",
  "nav.openMenu": "Ouvrir le menu",
  "nav.closeMenu": "Fermer le menu",
  "nav.licenseExpired": "Votre licence a expiré. Le tableau de bord est en lecture seule jusqu’à son renouvellement.",
  "nav.passwordLeaked": "Votre mot de passe figure dans une fuite de données connue : d’autres pourraient l’essayer.",
  "nav.passwordLeakedChange": "Modifiez-le dès maintenant dans",
  "nav.rental": "Location",
  "nav.inbox": "Boîte de réception",
  "nav.inboxUnread": "Boîte de réception, {count} non lu(s)",
  "nav.inboxReadAll": "Tout marquer comme lu",
  "nav.inboxEmpty": "Rien pour l’instant",
  "nav.pushRelay": "Relais push",
}

export default nav
